import Intercom from 'common/components/Intercom'

interface Props {
  showBookDemo?: boolean
}

const AuthFooter = ({ showBookDemo = true }: Props) => {
  return (
    <>
      {showBookDemo && (
        <div
          className={`relative mx-auto font-bold text-4xl 
        text-black mt-16 mb-16`}
        >
          New here?
          <a
            href="https://phrasee.co/book-a-demo/"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2"
          >
            Book a demo
          </a>
        </div>
      )}

      <div
        className={`sm:absolute sm:block sm:ml-16  sm:w-auto mt-8
         bottom-12 text-lg flex justify-center w-full`}
      >
        <a href="https://phrasee.co/" target="_blank" rel="noreferrer">
          ⓒ{new Date().getFullYear()} Phrasee
        </a>
        <a
          className="ml-16"
          href="https://phrasee.co/support/privacy/"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </div>
      <div className="sm:absolute mt-12 bottom-12 flex justify-center w-full">
        <a href="https://twitter.com/phrasee" target="_blank" rel="noreferrer">
          <img src="/images/brand-ps-social-media-twitter.svg" alt="" />
        </a>
      </div>
      <Intercom />
    </>
  )
}

export default AuthFooter
